import { render, staticRenderFns } from "./iconTitle.vue?vue&type=template&id=4899e08c&scoped=true&"
import script from "./iconTitle.vue?vue&type=script&lang=js&"
export * from "./iconTitle.vue?vue&type=script&lang=js&"
import style0 from "./iconTitle.vue?vue&type=style&index=0&id=4899e08c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899e08c",
  null
  
)

export default component.exports